import { getUriParams } from '../../../helpers';
import { CORE, gateway } from '../../api';

export default {
  buscarEmailEntradaBordero(pageable) {
    const queryParam = getUriParams(pageable);

    return gateway.get(`${CORE}/email-entrada-bordero/buscar-notificacoes?${queryParam}`);
  },
  buscarIdsEmailEntradaBordero() {
    return gateway.get(`${CORE}/email-entrada-bordero/buscar-notificacoes/ids`);
  },
  enviarEmailEntradaBordero(payload) {
    return gateway.post(`${CORE}/email-entrada-bordero/enviar-email`, payload);
  },
  excluirEmailEntradaBordero(idEmailEntradaBordero) {
    return gateway.get(`${CORE}/email-entrada-bordero/excluir-notificacao/${idEmailEntradaBordero}`);
  },
  buscarTelefonesDevedor(idEmailEntradaBordero) {
    return gateway.get(`${CORE}/email-entrada-bordero/telefone-devedor/${idEmailEntradaBordero}`);
  },
  buscarEmailsDevedor(idEmailEntradaBordero) {
    return gateway.get(`${CORE}/email-entrada-bordero/email-devedor/${idEmailEntradaBordero}`);
  },
  buscarIdProcessoPorIdEmailEntradaBordero(idEmailEntradaBordero) {
    return gateway.post(`${CORE}/email-entrada-bordero/buscar-id-processo/${idEmailEntradaBordero}`);
  },
  salvarDadosDevedor(idEmailEntradaBordero, payload) {
    return gateway.post(`${CORE}/email-entrada-bordero/salvar-devedor/${idEmailEntradaBordero}`, payload);
  },

};
